"use strict";
// import { Component, OnInit } from '@angular/core';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// @Component({
//   selector: 'preferred-equity',
//   templateUrl: './preferred-equity.component.html',
//   styleUrls: ['./preferred-equity.component.scss']
// })
// export class PreferredEquityComponent implements OnInit {
//   constructor() { }
//   ngOnInit() {
//   }
// }
var core_1 = require("@angular/core");
var static_1 = require("@angular/upgrade/static");
var PreferredEquityComponent = /** @class */ (function (_super) {
    __extends(PreferredEquityComponent, _super);
    function PreferredEquityComponent(elementRef, injector) {
        return _super.call(this, 'preferredEquity', elementRef, injector) || this;
    }
    return PreferredEquityComponent;
}(static_1.UpgradeComponent));
exports.PreferredEquityComponent = PreferredEquityComponent;
